$(".product-location-view li:contains('north vancouver')").remove();
$(".product-location-view li:contains('North Vancouver')").remove();
$(".product-location-view li:contains('North Van')").remove();
$(".product-location-view").addClass("show");

const mapConfig = {
    locations : [],
    "mapOptions": {
        "fullscreenControl": true,
        "mapTypeControl": false,
        "streetViewControl": false,
        "zoom": 15,
        "zoomControl": true,
        "maxZoom": 16
    },
    "mapsApiKey": "AIzaSyArvcHUUy3qGD2Nb0mmYaaswdPLCADnh2U",
    "capabilities": {
        "input": true,
        "autocomplete": true,
        "directions": false,
        "distanceMatrix": true,
        "details": false,
        "actions": false
    },
    "fsMessage": ""
}
/*
document.querySelector('.nav-store-location-btn').addEventListener('click', function(){
    document.querySelector('.nav-store-location-menu').classList.add('active');
})

document.querySelector('.nav-store-location').addEventListener('click', function(e){
    e.stopPropagation();
})
document.querySelector('body').addEventListener('click', function(){
    document.querySelector('.nav-store-location-menu').classList.remove('active');
})

*/


/** map API key
    james => AIzaSyArvcHUUy3qGD2Nb0mmYaaswdPLCADnh2U
    hs => AIzaSyDsxk9gD-ORYRDI5fh-2RQJEWgTlNYo6_Q
  */
// Get place ID : https://developers.google.com/maps/documentation/places/web-service/place-id
// Place data : https://developers.google.com/maps/documentation/javascript/place-data-fields
function womStores_search(key, val, arr) {
  let result = [];
  for (var i = 0; i < arr.length; i++) {
    if (arr[i][key] === val) {
      result.push(arr[i]);
    }
  }
  return result;
}
mapConfig.locations = window.storeData.locations;

var geocoder = null;
var map = null;
var customerMarker = null;

var gmarkers = []; // array of markers
var closest = []; // list of closest locations
var closestDistance = 0;

function showStoreData(data) {
  let myStore = data;
  let storeTiming = ``;
  for (const day in myStore.timing) {
    storeTiming += `<div class="${day} row"><span class="day-name col-4">${day}:</span> <span class="col-8 day-hours">${myStore.timing[day]}</span></div>`;
  }
  return `
      <div class="dropdown-loc_name mb-3 font-bold flex items-center w-100 justify-between">
        <div class="inline-flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="w-5 h-5 mr-2 flex-none" viewBox="0 0 48 48">
              <path d="M0 0h48v48H0z" fill="none"/>
              <path d="M24 14V6H4v36h40V14H24zM12 38H8v-4h4v4zm0-8H8v-4h4v4zm0-8H8v-4h4v4zm0-8H8v-4h4v4zm8 24h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4zm20 24H24v-4h4v-4h-4v-4h4v-4h-4v-4h16v20zm-4-16h-4v4h4v-4zm0 8h-4v4h4v-4z"/>
          </svg>
          ${myStore.name}
        </div>
        <small class="bg-black text-white py-1 px-2 text-xxs rounded-full whitespace-nowrap flex-none">${
          myStore.location_type
        }</small>
      </div>
      <div class="dropdown-loc_address flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="w-5 h-5 mr-2 flex-none" viewBox="0 0 48 48">
            <path d="M24 4c-7.73 0-14 6.27-14 14 0 10.5 14 26 14 26s14-15.5 14-26c0-7.73-6.27-14-14-14zm0 19c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
            <path d="M0 0h48v48H0z" fill="none"/>
        </svg>
        ${myStore.address2} ${myStore.address1}
      </div>
      <div class="dropdown-loc_phone  flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="w-5 h-5 mr-2 flex-none" viewBox="0 0 48 48">
            <path d="M0 0h48v48H0z" fill="none"/>
            <path d="M13.25 21.59c2.88 5.66 7.51 10.29 13.18 13.17l4.4-4.41c.55-.55 1.34-.71 2.03-.49C35.1 30.6 37.51 31 40 31c1.11 0 2 .89 2 2v7c0 1.11-.89 2-2 2C21.22 42 6 26.78 6 8c0-1.11.9-2 2-2h7c1.11 0 2 .89 2 2 0 2.49.4 4.9 1.14 7.14.22.69.06 1.48-.49 2.03l-4.4 4.42z"/>
        </svg>
        ${myStore.phone}
      </div>
      <div class="dropdown-loc_delivery mt-3  flex items-center">
  		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="w-5 h-5 mr-2 flex-none" viewBox="0 0 640 512"><path d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"/></svg>
		${myStore.allow_delivery ? "Delivery available" : "Delivery not available"}    
      </div>
      <div class="dropdown-loc_pickup  flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg"  width="18" height="18" class="w-5 h-5 mr-2 flex-none" viewBox="0 0 640 512"><path d="M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"/></svg>		
        ${
          myStore?.allow_pickup ? "Pickup available" : "Pickup not available"
        }    
      </div>
      <div class="dropdown-loc_timing mt-4">
      <div class="fw-bold mb-2  flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="w-5 h-5 mr-2 flex-none" viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"/></svg>
          Regular Hours
      </div><div class="ms-4 small">${storeTiming}</div>
    </div>
	`;
}
function loadClosestLocation(d) {
  let data = JSON.parse(d);
  //console.log(data);
  if (data.distance < 100) {
    mapMarkerCenter(
      mapConfig.locations[data.marker].latitude,
      mapConfig.locations[data.marker].longitude
    );
    $(".nav-store-location-current-toggle")
      .removeClass("hidden")
      .attr("data-num", data.marker);
    $(".dropdown-menu-text").html(
      showStoreData(mapConfig.locations[data.marker])
    );
    $("#nav-store-header").empty();
  } else {
    mapFitBounds();
    $(".nav-store-location-current-toggle").addClass("hidden");
    $("#nav-store-header").html(data.message);
  }
}

function initializeMap() {
  if(!window.google){
    setTimeout(function(){
      console.log('Checking for maps');
    },200);
    return;
  }
  // WOMF fix (Sep 2026): this was `new google.maps.Geocoder()`. codeAddress()
  // below reverse-geocoded coordinates we ALREADY have from ipdata.co, purely
  // to read the same coordinates back out and hand them to findClosestN().
  // That billed one Google Geocoding request per page view -- bot traffic drove
  // it to 1,685,225 requests / $6,446.74 in August 2026. This stub returns the
  // coordinates directly in the same shape, so nothing else had to change and
  // no Google API is called. Nearest-store selection is unaffected.
  geocoder = {
    geocode: function (request, callback) {
      callback([{ geometry: { location: request.location } }], "OK");
    },
  };

  /* WOMF fix (Sep 2026): only build the Google Map when its container is
     actually visible. #nav-store-location renders 0x0 inside a display:none
     menu with no reachable trigger, so this was constructing a Dynamic Map --
     a billed event -- on every page view for a map nobody could see.
     Markers below are still created (with map:null when there is no map), so
     findClosestN() and the nearest-warehouse distances are unaffected. */
  var womfMapEl = document.getElementById("nav-store-location");
  var womfMapVisible = false;
  if (womfMapEl) {
    var womfRect = womfMapEl.getBoundingClientRect();
    womfMapVisible = womfRect.width > 0 && womfRect.height > 0;
  }
  map = womfMapVisible
    ? new google.maps.Map(womfMapEl, {
        zoom: mapConfig.mapOptions.zoom,
        center: new google.maps.LatLng(
          mapConfig.locations[0].latitude,
          mapConfig.locations[0].longitude
        ),
        //mapTypeId: google.maps.MapTypeId.ROADMAP
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
      })
    : null;
  // https://developers.google.com/maps/documentation/javascript/controls

  // Get Place Info
  /*
  var request = {
    placeId: mapConfig.locations[0].placeID,
    fields: ['name', 'rating', 'formatted_phone_number', 'opening_hours', 'reviews' , 'user_ratings_total' ]
  };

  service = new google.maps.places.PlacesService(map);
  service.getDetails(request, callback);

  function callback(place, status) {
    if (status == google.maps.places.PlacesServiceStatus.OK) {
      console.log(place)
    }
  }
  */

  // Set markers for all locations
  var infoWindow = new google.maps.InfoWindow();
  var marker, i;
  var bounds = new google.maps.LatLngBounds();

  for (i = 0; i < mapConfig.locations.length; i++) {
    var pt = new google.maps.LatLng(
      mapConfig.locations[i].latitude,
      mapConfig.locations[i].longitude
    );

    bounds.extend(pt);

    marker = new google.maps.Marker({
      position: pt,
      map: map,
      //icon: locations[i][5],
      address: mapConfig.locations[i].address,
      title: mapConfig.locations[i].name,
      html: `<strong>${mapConfig.locations[i].name}</strong><br>${mapConfig.locations[i].address1}<br><a href="${mapConfig.locations[i].direction}" target="_blank" class="d-none" style="color:#000000;">Direction</a>`,
    });

    gmarkers.push(marker);

    google.maps.event.addListener(
      marker,
      "click",
      (function (marker, i) {
        return function () {
          infoWindow.setContent(marker.html);
          if (map) {
            infoWindow.open(map, marker);
          }
          //console.log(mapConfig.locations[i]);
          $(".dropdown-menu-text").html(showStoreData(mapConfig.locations[i]));
        };
      })(marker, i)
    );
  }

  // Show all markers
  // map.fitBounds(bounds);
  // codeAddress(mapConfig.locations[0].latitude, mapConfig.locations[0].longitude, 1);

  //var ip_data = getCookie('ip_data');
  var ip_data = sessionStorage.getItem("ip_data");
  var map_nearestStore = getCookie("map_nearestStore");

  if (ip_data) {
    var ip_data_json = JSON.parse(ip_data);
    if (map_nearestStore) {
      loadClosestLocation(map_nearestStore);
    } else {
      codeAddress(ip_data_json.latitude, ip_data_json.longitude, 1);
    }
  } else {
    if (map_nearestStore) {
      loadClosestLocation(map_nearestStore);
    } else {
      codeAddress(
        mapConfig.locations[0].latitude,
        mapConfig.locations[0].longitude,
        1
      );
    }
  }
  setPDPlocation();
  $("body").on("locationsWithDistanceSet", setPDPlocation);
}

function codeAddress(_lat, _lang, _num) {
  let lat = _lat ? _lat : mapConfig.locations[0].latitude;
  let lang = _lang ? _lang : mapConfig.locations[0].longitude;
  let num = _num ? _num : 1;
  var numberOfResults = num; //25;
  //var numberOfDrivingResults = 5;

  //var address = document.getElementById('address').value;
  var latlng = new google.maps.LatLng(lat, lang);

  geocoder.geocode(
    {
      //'address': address
      location: latlng,
    },
    function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        //console.log(results, status);

        //map.setCenter(results[0].geometry.location);

        //if (customerMarker) {customerMarker.setMap(null);}
        /*
      customerMarker = new google.maps.Marker({
        map: map,
        position: results[0].geometry.location
      });
      */

        closest = findClosestN(results[0].geometry.location, numberOfResults);
        console.log("closestDistance", closestDistance);

        var nearestStore = {
          distance: closestDistance,
          message: `
          <div class="no-near-store-message p-3 border border-dark">
			Word of mouth floors store is not available near your location, nearest store is in ${
        mapConfig.locations[closest].city +
        ", " +
        mapConfig.locations[closest].province_code
      }. Please contact us for better shipping rate for your location. 
			<br>
            <strong>Call Us</strong>: (604)-370-8769<br>

            <strong>Email Us</strong>: hello@wordofmouthfloors.com
          </div>
          <div class="fw-bolder mt-4 mb-3 uppercase">Our Stores</div>
		`,
          marker: closest,
        };
        setCookie("map_nearestStore", JSON.stringify(nearestStore), 1);
        if (nearestStore.distance < 100) {
          //map.setCenter(new google.maps.LatLng(mapConfig.locations[closest].latitude, mapConfig.locations[closest].longitude));
          mapMarkerCenter(
            mapConfig.locations[closest].latitude,
            mapConfig.locations[closest].longitude
          );
          //console.log( showStoreData (mapConfig.locations[closest]) );
          $(".nav-store-location-current-toggle")
            .removeClass("d-none")
            .attr("data-num", closest);
          $(".dropdown-menu-text").html(
            showStoreData(mapConfig.locations[closest])
          );
          $("#nav-store-header").empty();
        } else {
          mapFitBounds();
          $(".nav-store-location-current-toggle").addClass("d-none");
          $("#nav-store-header").html(nearestStore.message);
        }
        console.log("closest", closest);

        // get driving distance
        // closest = closest.splice(0, numberOfResults);
        // calculateDistances(results[0].geometry.location, closest, numberOfDrivingResults);
      } else {
        alert("Geocode was not successful for the following reason: " + status);
      }
    }
  );
}

function mapFitBounds() {
  if (!map) { return; }
  var mapBounds = new google.maps.LatLngBounds();
  for (var i = 0; i < gmarkers.length; i++) {
    mapBounds.extend(gmarkers[i].position);
  }
  map.fitBounds(mapBounds, 1);

  let locList = `<div class="list-group divide-y divide-blacl/10 text-sm">`;
  for (i = 0; i < mapConfig.locations.length; i++) {
    let locItem = mapConfig.locations[i];
    locList += `<div class="list-group-item list-group-item-action loc-list-action py-3 px-2" data-num="${i}">
      <div class="flex w-full justify-between items-center">
        <div class="mb-1 font-bold">${locItem.name}</div>
        <small class="bg-black text-white py-1 px-2 text-xs rounded-full whitespace-nowrap flex-none">${locItem.location_type}</small>
      </div>
      <p class="mb-0">${locItem.address2} ${locItem.address1}</p>
      <small class="text-light text-xs">${locItem.city}, ${locItem.province_code}</small>
    </div>`;
  }
  locList += `</div>`;
  $(".dropdown-menu-text").html(locList);
}

function mapMarkerCenter(lat, lan) {
  if (!map) { return; }
  map.setCenter(new google.maps.LatLng(lat, lan));
  map.setZoom(mapConfig.mapOptions.zoom);
}

$(".nav-store-location").on("click", ".loc-list-action", function () {
  let marker = $(this).data("num");
  mapMarkerCenter(
    mapConfig.locations[marker].latitude,
    mapConfig.locations[marker].longitude
  );
  $(".loc-list-action").removeClass("active");
  $(this).addClass("active");
  if (mapConfig.locations[marker].type == "showroom") {
    $("#nav-store-footer").html("");
  } else {
    $("#nav-store-footer").html(
      `<div class="pt-2">${
        mapConfig.locations[marker].message
          ? mapConfig.locations[marker].message
          : mapConfig.fsMessage
      }</div>`
    );
  }
});

$(".nav-store-location").on(
  "click",
  ".nav-store-location-current-toggle",
  function () {
    let marker = $(this).data("num");
    mapMarkerCenter(
      mapConfig.locations[marker].latitude,
      mapConfig.locations[marker].longitude
    );
    $(".dropdown-menu-text").html(showStoreData(mapConfig.locations[marker]));
  }
);

function findClosestN(pt, numberOfResults) {
  /*
  var closest = [];
  //document.getElementById('info').innerHTML += "processing " + gmarkers.length + "<br>";
  for (var i = 0; i < gmarkers.length; i++) {
    gmarkers[i].distance = google.maps.geometry.spherical.computeDistanceBetween(pt, gmarkers[i].getPosition());
    
    //document.getElementById('info').innerHTML += "process " + i + ":" + gmarkers[i].getPosition().toUrlValue(6) + ":" + gmarkers[i].distance.toFixed(2) + "<br>";
    
    gmarkers[i].setMap(null);
    closest.push(gmarkers[i]);
  }
  closest.sort(sortByDist);
  return closest;
  */
  var distances = [];
  var closest = -1;
  var allClosest = [];
  for (i = 0; i < gmarkers.length; i++) {
    gmarkers[i].distance =
      google.maps.geometry.spherical.computeDistanceBetween(
        pt,
        gmarkers[i].position
      );
    mapConfig.locations[i].distance = gmarkers[i].distance;
    //console.log(`${d/1000} KM`)
    distances[i] = gmarkers[i].distance;
    if (closest == -1 || gmarkers[i].distance < distances[closest]) {
      closest = i;
      closestDistance = Math.round(gmarkers[i].distance / 1000);
    }
    allClosest.push(gmarkers[i]);
  }
  let locationsWithDistance = mapConfig.locations.map(
    ({ id, distance }, index) => {
      return { id, distance };
    }
  );
  sessionStorage.setItem(
    "locationsWithDistance",
    JSON.stringify(locationsWithDistance)
  );
  $("body").trigger("locationsWithDistanceSet");
  return closest;
}

function sortByDist(a, b) {
  return a.distance - b.distance;
}

// calculate driving distance
/*
function calculateDistances(pt, closest, numberOfResults) {
  var service = new google.maps.DistanceMatrixService();
  var request = {
    origins: [pt],
    destinations: [],
    travelMode: google.maps.TravelMode.DRIVING,
    unitSystem: google.maps.UnitSystem.METRIC,
    avoidHighways: false,
    avoidTolls: false
  };
  for (var i = 0; i < closest.length; i++) {
    request.destinations.push(closest[i].getPosition());
  }
  service.getDistanceMatrix(request, function(response, status) {
    if (status != google.maps.DistanceMatrixStatus.OK) {
      alert('Error was: ' + status);
    } else {
      var origins = response.originAddresses;
      var destinations = response.destinationAddresses;
      var outputDiv = document.getElementById('side_bar');
      outputDiv.innerHTML = '';

      var results = response.rows[0].elements;
      // save title and address in record for sorting
      for (var i = 0; i < closest.length; i++) {
        results[i].title = closest[i].title;
        results[i].address = closest[i].address;
        results[i].idx_closestMark = i;
      }
      results.sort(sortByDistDM);
      for (var i = 0;
        ((i < numberOfResults) && (i < closest.length)); i++) {
        closest[i].setMap(map);
        outputDiv.innerHTML += "<a href='javascript:google.maps.event.trigger(closest[" + results[i].idx_closestMark + "],\"click\");'>" + results[i].title + '</a><br>' + results[i].address + "<br>" + results[i].distance.text + ' appoximately ' + results[i].duration.text + '<br><hr>';
      }
    }
  });
}

function sortByDistDM(a, b) {
  return (a.distance.value - b.distance.value)
}
*/
//google.maps.event.addDomListener(window, 'load', initialize);

window.initializeMap = initializeMap;

function setRegion_class(region) {
  $("body").addClass(region.toLowerCase());
  $(".form-province").val(region);

  /* Footer Links - Start */
  $('.footer-quicklinks a[href*="/collections/"]').each(function () {
    $(this).attr("href", $(this).attr("href") + "/" + region.toLowerCase());
  });

  /* Update best selling products */
  if ($("#best-selling-" + region.toLowerCase()).length) {
    $(".featured-products-row").html(
      $("#best-selling-" + region.toLowerCase()).html()
    );
    checkCartSmples();
  }
  /* Navbar Links - Start */
  $('.main-menu a[href*="/collections/"]').each(function () {
    var reg = region.toLowerCase();
    /*
      if($(this).parent().hasClass('parent') || $(this).parent().hasClass('grandparent') || $(this).parent().parent().hasClass('main-menu')){
      	$(this).addClass('collection-link');
        reg = '/'+reg;
        
      }else{
        $(this).addClass('tag-link');
        reg = '+'+reg
      
      }
      */
    let link_1 = $(this).attr("href").split("?");
    let fullLink = link_1[0].split("/collections/");
    //console.log(fullLink[1],( fullLink[1].match(new RegExp("/", "g")) || []).length);
    if ((fullLink[1].match(new RegExp("/", "g")) || []).length == 0) {
      $(this).addClass("collection-link");
      reg = "/" + reg;
    } else {
      $(this).addClass("tag-link");
      reg = "+" + reg;
    }
    let fullLinkSearch = link_1[1] ? "?" + link_1[1] : "";
    $(this).attr("href", link_1[0] + reg + fullLinkSearch);
  });

  /*  */
  var visited_collection = sessionStorage.getItem("visited_collection");
  if (!visited_collection) {
    let currPage = window.location.pathname;
    if (
      currPage.includes("/collections/") &&
      !currPage.includes("/products/")
    ) {
      // on collection page
      let currPagePath = currPage.split("/").pop();
      if (
        !currPagePath.split("+").includes(region.toLowerCase()) &&
        currPagePath != region.toLowerCase()
      ) {
        if (currPage.split("/collections/")[1].split("/").length > 1) {
          if (currPage.split("/collections/")[1].split("/").pop() != "") {
            window.location = currPage + "+" + region.toLowerCase();
          } else {
            window.location = currPage + region.toLowerCase();
          }
        } else {
          window.location = currPage + "/" + region.toLowerCase();
        }
      }
    }
  }

  $(".collection-nav .sidebar_collection_item a").each(function () {
    //$(this).attr('href', $(this).attr('href')+'/'+region.toLowerCase())
  });
}

function setPDPlocation() {
  if (window.location.pathname.includes("/products/")) {
    let productID = $(".product__form").data("id");
    let listCheckIcon = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 mr-2 text-accent"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg> ';
    if (productID && window.productLocationsScript) {
      $.getScript(window.productLocationsScript)
        .done(function (script, textStatus) {
          let currLoc = window.storeData.products
            .filter((product) => product.p.includes(productID))
            .map(({ l }, index) => {
              return l;
            });
          let currLocIDS = currLoc.map((id) => {
            return window.storeData.locations.find(
              (location) => location.id === id
            );
          });
          let currLocData = currLocIDS;
          let locationsWithDistance = sessionStorage.getItem(
            "locationsWithDistance"
          );
          if (locationsWithDistance) {
            //console.log(locationsWithDistance)
            let locationsWithDistanceJson = JSON.parse(locationsWithDistance);
            currLocData = currLocIDS.map((location) => {
              let locFound = locationsWithDistanceJson.find(
                (loc) => loc.id === location.id
              );
              if (locFound) {
                location.distance = locFound.distance;
              }
              return location;
            });
            console.log("loc sorted");
            currLocData.sort(sortByDist);
          }
          //console.log(currLocData);
          var allCities = [];
          let currLocHtml = currLocData.map(
            ({ id, city, province_code }, index) => {
              if (!allCities.includes(city)) {
                allCities.push(city);
                //console.log('all cities',allCities)
                return `<li class="check js ${province_code.toLowerCase()}" data-id="${id}"><a class="flex items-center " href="/pages/fulfilment-centre?location=${id}" title="">${listCheckIcon} ${city} ${province_code}</a></li>`;
              }
            }
          );
          let currViewHtml = currLocData.map(
            ({ id, city, province_code, location_type }, index) => {
              if (location_type == "Showroom") {
                return `<li class="check js ${province_code.toLowerCase()}" data-id="${id}"><a class="flex items-center " href="/pages/fulfilment-centre?location=${id}" title="">${listCheckIcon} ${city} Showroom</a></li>`;
              }
            }
          );
          console.log('currViewHtml:',currLocData.length,currViewHtml);
          currViewHtml.push(
            `<li class="flex items-center check js">${listCheckIcon} Available Online</li>`
          );
          //$('.product-location-view').html('<h4 class="product-location-title">VIEW IN-STORE AT::</h4><ul class="m-0 product-location-availability">'+currViewHtml.join('')+'</ul>');
          if(currLocData.length){
            $(".product-location-fulfillment").html(
              '<h4 class="mb-2 font-semibold uppercase product-location-title">Fulfilled Out Of:</h4><ul class="m-0 product-location-availability">' +
                currLocHtml.join("") +
                "</ul>"
            );
          }
          let ipData = sessionStorage.getItem("ip_data");
          if (ipData) {
            let ipDataJson = JSON.parse(ipData);
            let closestLoc = currLocData[0];
            $(".pdp-delivery-option .loc-city").text(
              ipDataJson.city + " " + ipDataJson.region
            );
            $(".pdp-delivery-option .loc-postal").text(
              ipDataJson.postal + " ***"
            );
            if (closestLoc?.allow_pickup) {
              if (closestLoc?.delivery_type == "Distribution Centre") {
                $(".pickup-card .card-text").html(
                  "Available for this item <br> 1 - 2 Business Days "
                );
              } else {
                $(".pickup-card .card-text").html(
                  "Available for this item <br> 5+ Business Days "
                );
              }
              //$('.pickup-card .card-text').text("Available for this item" );
              $(".pickup-card .card-link").attr(
                "href",
                "/pages/fulfilment-centre?location=" + closestLoc.id
              );
            } else {
              $(".pickup-card .card-text").text("Not available for this item");
              $(".pickup-card .card-link").addClass("hidden");
            }
            if (closestLoc?.delivery_type == "Distribution Centre") {
              $(".delivery-card .card-text").text("1 - 4 Business Days");
            } else {
              $(".delivery-card .card-text").text("5 - 10 Business Days");
            }
            $(".pdp-delivery-option").removeClass("hidden");
          }
        })
        .fail(function (jqxhr, settings, exception) {
          console.log("error while loading product locations");
        });
    }
  }
}

var user_set_region_code = getCookie("user_set_region_code");
//console.log(user_set_region_code)
let womStores_near = [];

/*
//let apiKey = '8bb890d86b5be957a5e55d7951eec54c65f61a2666aea06ca8a29d42';
let apiKey = "593275bd0973d0087e6183a10121196bfb8ebd640f88f34847d8ffd0";

//var ip_data = getCookie('ip_data');
var ip_data = sessionStorage.getItem("ip_data");

if (ip_data) {
  var ip_data_json = JSON.parse(ip_data);
  $(".nav-store-location-text").text(ip_data_json.city);
  if ( ["CA","US"].includes(ip_data_json.country_code) ) {
    sessionStorage.setItem("user_region_code", ip_data_json.region_code);
    setRegion_class(ip_data_json.region_code);
  }

  $(".loc-city").text(ip_data_json.city + " " + ip_data_json.postal + "***");
  $(".loc-postal").text(ip_data_json.postal + "***");
  initializeMap();
} else {
  $.getJSON("https://api.ipdata.co?api-key=" + apiKey, function (data) {
    $(".nav-store-location-text").text(data.city);
    //setCookie('ip_data', JSON.stringify(data), 1);

    sessionStorage.setItem("ip_data", JSON.stringify(data));
    if ( ["CA","US"].includes(data.country_code) ) {
      sessionStorage.setItem("user_region_code", data.region_code);
      setRegion_class(data.region_code);
      
    }

    $(".loc-city").text(data.city + " " + data.postal + "***");
    $(".loc-postal").text(data.postal + "***");
    initializeMap();
  });
}
*/

$(".filter-location.not-selected").click(function (e) {
  e.preventDefault();
  var thisLocation = $(this).attr("data-location").toUpperCase();
  setCookie("user_set_region_code", thisLocation, 1);

  var link = $(this).attr("href");
  $(".filter-location.link--remove").each(function () {
    let loc = $(".filter-location.link--remove").data("location");
    link = link
      .replace("+" + loc, "")
      .replace("/" + loc + "+", "/")
      .replace("/" + loc, "/");
  });
  window.location = link;
  //console.log(link)
  var cookieCheck = setInterval(function () {
    //console.log(getCookie('user_set_region_code'));
    if (getCookie("user_set_region_code") === thisLocation) {
      clearInterval(cookieCheck);
      //window.location = link;
    }
  }, 500);
});
if ($(".filter-location.link--remove").length) {
  $(".filter-location.link--remove").each(function () {
    let loc = $(this).data("location");
    $(".filter-location").each(function () {
      $(this).attr(
        "href",
        $(this)
          .attr("href")
          .replace("+" + loc, "")
          .replace("/" + loc + "+", "/")
          .replace("/" + loc, "/")
      );
    });
  });
}
/*
let currVendor = $(".vendor-map-link");
if (currVendor.length) {
  let vendorLocs = window.storeData.locations.filter((location) => {
    return location.brand.includes(currVendor.data("vendor").trim());
  });
  if (vendorLocs.length) {
    currVendor.removeClass("hidden").addClass('inline-flex');
  }
}
*/
